import { Component, Input, OnInit } from '@angular/core';
import { isUndefined } from 'src/app/services/codeUtils';
import { AudioService } from 'src/app/services/audio/audio.service';
import { NavOverriderService } from 'src/app/services/navOverrider/nav-overrider.service';
import { Navigator } from '../menu/navigator';

@Component({
  selector: 'back-button',
  templateUrl: './custom-back.component.html',
  styleUrls: ['./custom-back.component.scss'],
})
export class CustomBackComponent implements OnInit {

  private navOverrideSubcriber;
  @Input() extendBackBtnFunction: any;
  @Input() overrideBackBtnFunction: any;
  @Input() customText: any;


  constructor(
    private readonly navigator: Navigator,
    public navOverride: NavOverriderService,
    private audioService: AudioService
  ) { }

  ngOnInit() {
    try {
      if (this.navOverrideSubcriber) this.navOverrideSubcriber.unsubscribe();
    } catch {
      console.log('Subcription error');
    }

    this.navOverrideSubcriber = this.navOverride
      .getCustomCloseFunction()
      .subscribe(customCloseFunction => {
        if (
          typeof customCloseFunction === 'function' ||
          customCloseFunction === undefined
        ) {
          console.log("custome", customCloseFunction)
          this.overrideBackBtnFunction = customCloseFunction;
        }
      });
  }


  protected onBack(event?) {
    if (!isUndefined(this.overrideBackBtnFunction)) {
      try {
        return this.overrideBackBtnFunction();
      } catch {
        return this.navigator.back();
      }
    }

    return this.onBackDefault();
  }

  onBackDefault() {
    if (!isUndefined(this.extendBackBtnFunction)) {
      try {
        return this.extendBackBtnFunction()
      }
      catch (error) {
        return console.error(error);
      }
    }
    return this.navigator.back();
  }

  ngOnDestroy() {
    try {
      this.navOverrideSubcriber?.unsubscribe();
    } catch (error) {
      console.error('Failed to unsubscribe Navbar:', error);
    }
  }

}
